import ExcelJS from "exceljs";
import { formatDateTimeWithoutSec } from "../../../Common/helper/helpar";
import useGrievanceReportStore from "./store/grievanceReportStore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
export const ExportGrievanceDetailedReport = () => {
    const { grievanceReportData} = useGrievanceReportStore();

    const downloadExcel = async () => {
      const { FromDateTime, ToDateTime } = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};
      
      // Get current date/time for header
      const currentDate = new Date();
      const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
      const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
      const filterDateRange =
        FromDateTime && ToDateTime ? `(${formatDateTimeWithoutSec(FromDateTime)} to ${formatDateTimeWithoutSec(ToDateTime)})` : "";
      
      const reportTitle = `Grievance Detailed Report ${filterDateRange}`;
      const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Zone");
  
      const boldFont = { bold: true };
      const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };
  
      // Define number of columns (adjust dynamically)
      const columnCount = 6; // Change if more columns are added
  
      // --- Header Row 1: Report Generated Date/Time ---
      const headerRow1 = worksheet.addRow([generatedText]);
      worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, columnCount);
      headerRow1.getCell(1).font = boldFont;
      headerRow1.getCell(1).alignment = centerAlignment;
  
      // --- Header Row 2: Report Title ---
      const headerRow2 = worksheet.addRow([reportTitle]);
      worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, columnCount);
      headerRow2.getCell(1).font = boldFont;
      headerRow2.getCell(1).alignment = centerAlignment;
  
      // --- Table Header Row ---
      const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Complaint Number",
        "IE Engineer Name",
        "KPI",
        "Description",
        "Status"
      ]);
      tableHeaderRow.eachCell((cell) => {
        cell.font = boldFont;
        cell.alignment = centerAlignment;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      });

      const sortedGrievanceReportData = [...grievanceReportData].sort((a, b) => {
        if (a.status === "Closed") return 1;
        if (b.status === "Closed") return -1;
        return 0;
    });
    
  
      // --- Data Rows ---
      grievanceReportData.forEach((item, index) => {
        const row = worksheet.addRow([
          index + 1,
          item.complaintNo?? "N/A",
          item.ieEngineerName?? "N/A",
          item.kpiCategoryName?? "N/A",
          item.description?? "N/A",
          item.status,
        ]);
        row.eachCell((cell) => {
          cell.alignment = centerAlignment;
        });
      });
  
      // --- Adjust Column Widths ---
      worksheet.columns = [
        { width: 10 },  
        { width: 20 }, 
        { width: 25 },  
        { width: 25 }, 
        { width: 25 }, 
        { width: 25 }, 
      ];
  
      // --- Save and Download Workbook ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "GrievanceDetailedReport.xlsx";
      a.click();
      URL.revokeObjectURL(url);
  };
  


  const downloadPDF = () => {
    const doc = new jsPDF();

    // Centered Title
    doc.text("Grievance Detailed Report", doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });

    // Generate table with centered text & headers
    autoTable(doc, {
      head: [["S.No", "Complaint Number","IE Engineer Name", "KPI","Description", "Status"]],
      body: grievanceReportData.map((row, index) => [
        { content: index + 1, styles: { halign: "center" } },
        { content: row.complaintNo || "N/A", styles: { halign: "center" } },
        { content: row.ieEngineerName || "N/A", styles: { halign: "center" } },
        { content: row.kpiCategoryName || "N/A", styles: { halign: "center" } },
        { content: row.description || "N/A", styles: { halign: "center" } },
        { content: row.status , styles: { halign: "center" } }
      ]),
      margin: { top: 20 },
      styles: { halign: "center" }, // Centers all table text
      headStyles: { halign: "center", fontStyle: "bold",  } // Centers header with bold red background
    });

    // Save the PDF
    doc.save("Grievance Detailed Report.pdf");
  };

  return (
    <div className="d-flex">
    <button type="button" className="btn btn-excel" onClick={downloadPDF}>
    <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
  </button>
    <button type="reset" className="btn btn-excel" onClick={downloadExcel}>
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
    </div>
  );
};
